import React from 'react';
import Image from 'next/image';
import Container from '../Container';
import Leadbox from '../Leadbox';
import Link from '../Link';
import PostFuckingFooter from '../PostFuckingFooter';
import {
  Grid,
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import FooterTags from '../FooterTags';
import Modal from '../Modal';
import InfoIcon from '@mui/icons-material/Info';
import TiktokIcon from '../TiktokIcon';
import { getWhatsappLink } from '../../utils/utils';
import useHook from './useHook';
import styles from './styles.module.scss';

const Footer = () => {

  const { vacaciones, year, tematicas } = useHook();

  return (<footer role="contentinfo">
    <div className={styles.contenedor}>
      <Container width="1200px">
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <strong className={styles.tituloColumna}>Comprar</strong>
            <Link className={styles.footerBtn} href="/tienda">Tienda</Link>
            <Link className={styles.footerBtn} href="/productos/novedades">Novedades</Link>
            <Link className={styles.footerBtn} href="/productos/destacados">Destacados</Link>
            <Link className={styles.footerBtn} href="/tematicas">Temáticas</Link>
            <Link className={styles.footerBtn} href="/productos/tipo/bonete">Bonetes</Link>
            <Link className={styles.footerBtn} href="/catalogo-mayorista">Mayorista</Link>
            <Link className={styles.footerBtn} href="/inspo">Inspo</Link>
            <Link className={styles.footerBtn} href="/carrito">Carrito</Link>
            <Link className={styles.footerBtn} href="/mi-cuenta">Mi cuenta</Link>
            <br /><br />
          </Grid>
          <Grid item xs={12} md={3}>
            <strong className={styles.tituloColumna}>Temáticas destacadas</strong>
            {tematicas?.map((item: any) => (
              <Link className={styles.footerBtn} key={item.id} href={`/productos/tematica/${item.attributes.slug}`}>{item.attributes.nombre}</Link>
            ))}
            <Link className={styles.footerBtn} href="/tematicas">+ Ver todas</Link>
            <br /><br />
          </Grid>
          <Grid item xs={12} md={3}>
            <strong className={styles.tituloColumna}>Atención al cliente</strong>
            <Link className={styles.footerBtn} href="/preguntas-frecuentes">Preguntas frecuentes</Link>
            <Link className={styles.footerBtn} href="/nosotros">Nosotros</Link>
            <Link className={styles.footerBtn} external={true} href={getWhatsappLink()}>Escribinos por Whatsapp</Link>
            <Link className={styles.footerBtn} external={true} href="mailto:info@we-celebrate.com.ar">Envianos un email</Link>
            <Link className={styles.footerBtn} external={true} href="https://www.instagram.com/wecelebrateok/?hl=es">Seguinos en Instagram </Link>
            <Link className={styles.footerBtn} href="/terminos-y-condiciones">Términos y condiciones</Link>

            <br /><br />
          </Grid>
          <Grid item xs={12} md={3}>
            <Leadbox />
          </Grid>
          <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
            <Container width="600px">
              <Link href="/">
                <div style={{ width: "fit-content", margin: "auto", borderRadius: "20px" }}>

                  <Image
                    className={styles.logo}
                    src="/img/logo-2022-png.png"
                    alt="We Celebrate, el cotillón más lindo, listo para usar!"
                    width={233}
                    height={105}
                  />
                </div>
              </Link>
              <br /><br />
              <strong className={styles.claim}>El cotillón más lindo y original, listo para usar</strong>
              <p style={{ fontSize: '0.8rem' }}>Festejá tus eventos y fiestas con nuestros diseños innovadores realizados artesanalmente. Tenemos muchas categorías para decorarle a los que más querés!</p>
              <div className={styles.contenedorRRSS}>
                <a className={styles.linkRRSS} href="https://www.instagram.com/wecelebrateok/?hl=es" aria-label="Instagram">
                  <div className={`${styles.rrss} ${styles.rrssInstagram}`}>
                    <InstagramIcon />
                  </div>
                </a>
                <a className={styles.linkRRSS} href="https://ar.pinterest.com/wecelebratear/" aria-label="Pinterest">
                  <div className={`${styles.rrss} ${styles.rrssPinterest}`}>
                    <PinterestIcon />
                  </div>
                </a>
                <a className={styles.linkRRSS} href="https://www.tiktok.com/@wecelebrateok?_r=1&_t=ZM-91g2dkY3nxY" aria-label="Tik Tok">
                  <div className={`${styles.rrss} ${styles.rrssTiktok}`}>
                    <TiktokIcon />
                  </div>
                </a>
              </div>

              <div className={styles.divisor} />
              <br />
              <p style={{ fontSize: '0.8rem' }}>{year} || Todos lo derechos reservados.</p>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </div>

    <PostFuckingFooter />

    <FooterTags />
    <Modal
      open={vacaciones}
      width="500px"
      height="280px"
      body={
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          gap: '20px',
          flexDirection: 'column',
          textAlign: 'center'
        }}>
          <InfoIcon
            color='secondary'
            sx={{ fontSize: "2.4rem" }}
          />
          <div>
            <p><b>Cerrado por vacaciones</b></p>
            <p>Volvemos el martes 7 de abril ✨️</p>
          </div>
        </div>
      }
    />
  </footer>);
};

export default Footer;
